import {
  DueDateFilterValue,
  NO_DUE_DATE_VALUE,
  useDueDateFilterService
} from './dueDateFilterService';

import {
  useDueDateCounterService
} from '../List/DueDateCounter';

import { formatDateToStartOfDay } from '../utils/dateUtils';

export enum FilterOptionType {
  PAST_DUE = 'PAST_DUE',
  TODAY = 'TODAY',
  NO_DUE_DATE = 'NO_DUE_DATE',
  ALL_TASKS = 'ALL_TASKS',
}

export function useDueDateFilterOption(
  type: FilterOptionType
) {

  const filterService = useDueDateFilterService();

  const currentValue = filterService.getFilterValue();

  const dueDateCounterService = useDueDateCounterService();

  const getValue = (): DueDateFilterValue => {
    if (type === FilterOptionType.TODAY) {
      const today = formatDateToStartOfDay(new Date());
      return [today, today];
    } else if (type === FilterOptionType.PAST_DUE) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      return [null, formatDateToStartOfDay(yesterday)];
    } else if (type === FilterOptionType.NO_DUE_DATE) {
      return NO_DUE_DATE_VALUE;
    } else {
      return null;
    }
  };

  const onClick = () => {
    filterService.setFilterValue(getValue());
  };

  const isActive = () => {
    if (currentValue && getValue()) {
      return currentValue.toString() === getValue()!.toString();
    } else {
      return currentValue === getValue();
    }
  };

  const getCount = () => {
    if (type === FilterOptionType.TODAY) {
      return dueDateCounterService.getNumberOfTodayTasks();
    } else if (type === FilterOptionType.PAST_DUE) {
      return dueDateCounterService.getNumberOfPastDueTasks();
    } else if (type === FilterOptionType.ALL_TASKS) {
      return dueDateCounterService.getTotalNumberOfTasks();
    } else if (type === FilterOptionType.NO_DUE_DATE) {
      return dueDateCounterService.getNumberOfNoDueDateTasks();
    } else {
      return 0;
    }
  };

  return {
    onClick,
    isActive,
    getCount,
  };
}
